import { CancelToken } from 'axios'
import apiInstance from '../../backend-api.setup'
import { CatalogInterface } from '../../../interface/rank/catalog.interface'
import { ApiPathConfig } from '../../../config/ApiPathConfig'

export const getHomeTopCatalogsService = (cancelToken?: CancelToken) =>
  apiInstance.get<CatalogInterface[]>(ApiPathConfig.TOP_HOME_CATALOGS, {
    cancelToken,
  })
